import { useEffect, useReducer } from 'react';

// enums for action
const ACTIONS = {
  SET_LEFT_END: 'SET_LEFT_END',
  SET_RIGHT_END: 'SET_RIGHT_END',
  SET_MIDDLE: 'SET_MIDDLE',
  SET_NONE: 'SET_NONE',
};

// initial arguments for useReducer,
// ...this will be the args for initializer function,
// ...which eventually produce the initial states
const initArgs = {
  isLeftEnd: null,
  isRightEnd: null,
};

function initializer(args) {
  return {
    isLeftEnd: args.isLeftEnd,
    isRightEnd: args.isRightEnd,
  };
}

const scrollEndReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_LEFT_END:
      return {
        isLeftEnd: true,
        isRightEnd: false,
      };
    case ACTIONS.SET_RIGHT_END:
      return {
        isLeftEnd: false,
        isRightEnd: true,
      };
    case ACTIONS.SET_NONE:
      return {
        isLeftEnd: true,
        isRightEnd: true,
      };
    case ACTIONS.SET_MIDDLE:
      return {
        isLeftEnd: false,
        isRightEnd: false,
      };
    default:
      return state;
  }
};

export const useScrollEnd = (ref, customTrigger, deviationValue = 1) => {
  const [scrollEnd, dispatchScrollEnd] = useReducer(
    scrollEndReducer,
    initArgs,
    initializer,
  );

  function handleScrollDetect(e) {
    if (e?.target) {
      // 默认值有个1，所以这里把1减去
      const isLeftEnd = e.target.scrollLeft <= deviationValue - 1;
      // console.log('aaa: ', e.target.scrollWidth, e.target.scrollLeft, e.target.clientWidth, deviationValue)
      const isRightEnd =
        e.target.scrollWidth - e.target.scrollLeft - e.target.clientWidth <
        deviationValue;

      const isNone =
        e.target.scrollWidth <= e.target.clientWidth + deviationValue;

      // console.log('isLeftEnd: ', isLeftEnd);
      // console.log('isRightEnd: ', isRightEnd);
      // console.log('isNone: ', isNone)
      if (isLeftEnd && !isRightEnd) {
        dispatchScrollEnd({ type: ACTIONS.SET_LEFT_END });
      } else if (!isLeftEnd && isRightEnd) {
        dispatchScrollEnd({ type: ACTIONS.SET_RIGHT_END });
      } else if (isNone) {
        dispatchScrollEnd({ type: ACTIONS.SET_NONE });
      } else {
        dispatchScrollEnd({ type: ACTIONS.SET_MIDDLE });
      }
    }
  }

  useEffect(() => {
    // detect initial state for scrollEnd,
    // ...can also be triggered by a custom trigger
    // ...provided by component using this hook
    handleScrollDetect({ target: ref.current });
  }, [customTrigger]);

  useEffect(() => {
    // check if addEventListener is ready to use
    const isSupported = ref && ref.current && ref.current.addEventListener;
    if (!isSupported) {
      return;
    }

    if (isSupported) {
      // add the handler function on 'scroll' event
      ref.current.addEventListener('scroll', handleScrollDetect);
    }
    return () => {
      // clean up after component unmount
      ref?.current?.addEventListener('scroll', handleScrollDetect);
    };
  }, [ref]);

  return scrollEnd;
};
